export default __webpack_public_path__ + "static/media/chile1.e4e83788.jpg";